import { Component, OnInit, Input } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss']
})
export class RatingComponent extends BaseComponent implements OnInit {

  @Input() rating = 5;
  @Input() maxRating = 5;
  @Input() count = 0;
  @Input() bigImg = false;

  ratings: number[] = [];

  constructor() {
    super();
  }

  ngOnInit() {

    for (let i = 0; i < Math.floor(this.rating); i++) {
      this.ratings.push(1);
    }

    let i = this.rating;
    const hasHalf = this.rating % 1 >= 0.5;
    if (hasHalf) {
      this.ratings.push(2);
      i++;
    }

    for (i; i < this.maxRating; i++) {
      this.ratings.push(0);
    }
  }

}
